<script>
import { mapGetters } from 'vuex'
import { gsap } from 'gsap'
import { CSSPlugin } from 'gsap/CSSPlugin'
gsap.registerPlugin(CSSPlugin)

export default {
  name: 'HelpLinksOverlay',
  props: {
    loggedIn: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      btnArray: [],
      inTimeline: null,
      outTimeline: null,
      overlayActive: false,
      topButtonHeight: null,
      buttonContainerOpaque: false // not sure what to name this.  This sets the button container to an opacity of 0 so they are invisible before the animation starts.
    }
  },
  computed: {
    ...mapGetters({
      links: 'helpLinks/links',
      promoLinks: 'helpLinks/promoLinks'
    }),
    helpButtonLinks () {
      return this.loggedIn ? this.links : this.promoLinks
    },
    routeName () {
      return this.$route.name
    }
  },
  methods: {
    buildInTimeline () {
      const tl = gsap.timeline({ defaults: { duration: 1, ease: 'back.inOut' } })
      tl.pause()
      tl.set(this.$refs.buttonContainer, { opacity: 100 })
      tl.set('#collapser', { rotate: -180 })
      tl.from(this.$refs.collapseButton, { bottom: '2rem', opacity: 1, onReverseComplete: this.hideButtonContainer })
      tl.to('#collapser', { rotate: 0 }, '<0')
      for (let i = 0; i < this.btnArray.length; i++) {
        tl.from(this.btnArray[i], { y: 100, opacity: 0 }, '<0.12')
      }
      // tl.set({ onComplete: this.testyyyy })
      return tl
    },
    buildOutTimeline () {
      const outTl = gsap.timeline({ defaults: { duration: 1, ease: 'back.Out' } })
      outTl.pause()
      outTl.to('#collapser', { rotate: 180 }, '<0')
      for (let i = this.btnArray.length; i > 0; i--) {
        outTl.to(this.btnArray[i], { y: 100, opacity: 0 }, '<0.12')
      }
      return outTl
    },
    hideButtonContainer () {
      this.buttonContainerOpaque = false
    },
    showButtons () {
      this.buttonContainerOpaque = true
      this.overlayActive = true
      this.inTimeline.play()
    },
    hideButtons () {
      this.inTimeline.reverse()
      this.overlayActive = false
    },
    toggleButtons () {
      this.overlayActive ? this.hideButtons() : this.showButtons()
    },
    buildTimelines () {
      this.inTimeline = this.buildInTimeline()
      this.outTimeline = this.buildOutTimeline()
    },
    handleClick (link) {
      switch (link.action.toUpperCase()) {
        case 'ROUTE':
          this.handleRouteAction(link)
          break
        case 'HYPERLINK':
          this.handleHyperLink(link)
          break
        case 'EVENT':
          this.handleEvent(link)
          break
      }
    },
    // Deal with clicks
    handleRouteAction (link) {
      // console.log('handleRouteAction')
      // if a targetTour and targetStep have been passed we need to set it in the store
      if (link.targetTour && link.targetStep) {
        this.$store.dispatch('tours/setTourTarget', {
          targetTour: 'link.targetTour',
          targetStep: 'link.targetStep'
        })
      }
      const params = link.routeParams ? link.routeParams : ''
      this.$router.push({ name: link.target, params: { params } })
    },
    handleHyperLink (link) {
      window.open(link.target, '_blank')
    },
    handleEvent (link) {}
  },
  created () {
    this.btnArray = []
    this.inTimeline = null
  },
  mounted () {
    // this.$store.dispatch('helpLinks/resetLinks')
    this.btnArray = []
    setTimeout(() => {
      this.$nextTick(() => {
        this.btnArray = this.$refs.buttonContainer.querySelectorAll('.button')
        const topBtnHeight = `${this.btnArray[0].offsetHeight}px`
        this.$refs.collapseButton.style.minHeight = topBtnHeight
        this.$refs.collapseButton.style.minWidth = topBtnHeight
        this.buildTimelines()
        this.showButtons()
      })
    }, 2000)
  }
}
</script>

<template>
  <MountingPortal
    mount-to="#help-overlay-portal"
    append
    name="modal"
  >
    <div
      ref="helpLinksOverlay"
      class="help-links-overlay is-transparent"
    >
      <div class="ql-row">
        <div class="button-column mr-2">
          <div
            ref="buttonContainer"
            class="button-container help-links-button-list"
            :class="{'hide-container': !buttonContainerOpaque}"
          >
            <template v-for="(link, index) in helpButtonLinks">
              <a
                v-if="$router.currentRoute.name !== link.target"
                :key="`${link.label}_${index}`"
                class="help-link-button"
                :class="link.cssClass"
                :style="link.style"
                @click="handleClick(link)"
              >
                {{ link.label }}
              </a>
            </template>
          </div>
        </div>
        <div class="collapse-button-column">
          <a @click="toggleButtons" ref="collapseButton" class="collapse-button" :title="overlayActive ? 'Hide quick-links buttons' : 'Show quick-links buttons'">
            <svg id="collapser" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><g fill="#fff"><path d="M10,0c5.52,0,10,4.48,10,10s-4.48,10-10,10S0,15.52,0,10,4.48,0,10,0"></path></g><g id="background" class="fore"><path d="M10,0c5.52,0,10,4.48,10,10s-4.48,10-10,10S0,15.52,0,10,4.48,0,10,0M5,8l5,5,5-5H5Z"></path></g></svg>
          </a>
        </div>
      </div>
    </div>
  </MountingPortal>
</template>
<style lang="scss">
  .help-links-button-list {
    display: flex;
    opacity: 0;
    flex-direction: column;
    button.button, a.button {
      //border: none;
      box-shadow: 0 1px 2px rgba(0,0,0,0.07), 0 2px 4px rgba(0,0,0,0.07), 0 4px 8px rgba(0,0,0,0.07), 0 8px 16px rgba(0,0,0,0.07), 0 16px 32px rgba(0,0,0,0.07), 0 32px 64px rgba(0,0,0,0.07);
      &.is-outlined {
        background-color: #fff;
      }
    }
    .button:not(:last-child) {
      margin-bottom: 1rem;
    }
  }
</style>
<style scoped lang="scss">
  #collapser {
    box-shadow: 0 1px 2px rgba(0,0,0,0.07), 0 2px 4px rgba(0,0,0,0.07), 0 4px 8px rgba(0,0,0,0.07), 0 8px 16px rgba(0,0,0,0.07), 0 16px 32px rgba(0,0,0,0.07), 0 32px 64px rgba(0,0,0,0.07);
    background-color: transparent;
    .fore {
      fill: $primary;
    }
    border-radius: 50%;
    transform: rotate(180deg);
  }
  .quicklink-button {
    backface-visibility: hidden;
    z-index: 1;
    transition: all 1000ms;
  }
  .help-links-overlay {
    background-color: hsla(200, 36%, 54%, 0.75);
    backdrop-filter: blur(8px);
    position: fixed;
    bottom: 0;
    right: 10rem;
    z-index: 50;
    padding: 0.25rem 1rem 1.5rem 1rem;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    box-shadow: $shadow-6dp;
    &.is-transparent {
      background-color: transparent;
      backdrop-filter: none;
      box-shadow: none;
      padding: 0 0 2rem 0;
      .content-row {
        border: 1px solid $gray-light;
        padding: 0.25rem 1rem;
        background-color: $white;
      }
      .expansion-button {
        color: $primary;
      }
    }
    .expansion-button {
      transition: transform 0.45s ease-out;
      transform: rotate(180deg);
    }
    &.is-active {
      .expansion-button {
        transform: rotate(0deg);
      }
    }
    .ql-row {
      display: flex;
      .button-column {
        display: flex;
        flex-direction: column;
      }
      .collapse-button-column {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }
      .collapse-button {
        position: absolute;
        bottom: auto;
        padding: 0;
        margin: 0;
      }
    }
  }
</style>
